import { Button } from '@/components/ui/button';
import { CheckCircle2, AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface WorkflowFooterProps {
  isStepCompleted: boolean;
  isCarOwner: boolean;
  hasStation: boolean;
  onCompleteStep: () => void;
}

/**
 * Footer bar with the complete-step action button.
 * Rendered inside the WorkflowLayout — no fixed positioning needed.
 */
export const WorkflowFooter = ({
  isStepCompleted,
  isCarOwner,
  hasStation,
  onCompleteStep,
}: WorkflowFooterProps) => {
  const { t } = useTranslation();

  return (
    <div className="px-6 py-3">
      <div className="max-w-4xl mx-auto">
        <Button
          className="w-full h-14 text-base font-semibold"
          size="lg"
          onClick={onCompleteStep}
          disabled={!isCarOwner || isStepCompleted || !hasStation}
        >
          {isStepCompleted ? (
            <>
              <CheckCircle2 className="mr-2 h-5 w-5" />
              {t('workflow.stepCompleted')}
            </>
          ) : !isCarOwner ? (
            t('workflow.claimCarToComplete')
          ) : !hasStation ? (
            <>
              <AlertTriangle className="mr-2 h-5 w-5" />
              {t('workflow.claimStationFirst')}
            </>
          ) : (
            <>
              <CheckCircle2 className="mr-2 h-5 w-5" />
              {t('workflow.completeStep')}
            </>
          )}
        </Button>
      </div>
    </div>
  );
};
